import PolicyBlock from './PolicyBlock'

export default PolicyBlock
